var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/types.ts
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["Request"] = "request";
  EventType2["Response"] = "response";
  return EventType2;
})(EventType || {});
var ErrorType = /* @__PURE__ */ ((ErrorType2) => {
  ErrorType2["SendTransactionError"] = "SendTransactionError";
  return ErrorType2;
})(ErrorType || {});

// src/Messenger.ts
var Messenger = class {
  constructor({ walletWindow, appInfo }) {
    this.walletWindow = walletWindow;
    this.appWindow = window;
    this.appInfo = appInfo;
  }
  sendMessage(event) {
    const messageId = crypto.randomUUID();
    this.postMessage({
      appId: crypto.randomUUID(),
      appInfo: this.appInfo,
      messageId,
      target: "CyberWallet",
      event
    });
    return messageId;
  }
  onMessage(callback) {
    this.appWindow.onmessage = (event) => {
      callback(event.data);
    };
  }
  postMessage(message) {
    this.walletWindow.postMessage(message, "*");
  }
};
var Messenger_default = Messenger;

// src/Chain.ts
var Chain = class {
  constructor({
    id,
    sendTransaction,
    appId
  }) {
    this.cyberAccount = null;
    this.id = id;
    this.sendTransactionBase = sendTransaction;
    this.appId = appId;
  }
  setCyberAccount(cyberAccount) {
    this.cyberAccount = cyberAccount;
  }
  sendTransaction(transaction, option) {
    return __async(this, null, function* () {
      if (!this.cyberAccount) {
        return;
      }
      return yield this.sendTransactionBase(
        __spreadProps(__spreadValues({}, transaction), {
          from: transaction.from || this.cyberAccount.address,
          ctx: {
            chainId: this.id,
            owner: this.cyberAccount.ownerAddress,
            appId: this.appId
          }
        }),
        option
      );
    });
  }
};
var Chain_default = Chain;

// src/config/chains.ts
import {
  mainnet,
  optimism,
  optimismGoerli,
  polygon,
  polygonMumbai,
  arbitrum,
  arbitrumGoerli,
  linea,
  lineaTestnet,
  base,
  baseGoerli,
  bsc,
  bscTestnet,
  scrollSepolia,
  scroll,
  optimismSepolia
} from "viem/chains";
var opBnbMainnet = {
  id: 204,
  name: "opBNB",
  network: "opBNB",
  rpcUrls: {
    public: {
      http: [
        "https://opbnb-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3"
      ]
    },
    default: {
      http: [
        `https://opbnb-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3`
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "BlockScout",
      url: "https://opbnbscan.com"
    }
  },
  nativeCurrency: bsc.nativeCurrency
};
var opBnbTestnet = {
  id: 5611,
  name: "opBNB Testnet",
  network: "opBNB testnet",
  rpcUrls: {
    public: {
      http: [
        "https://opbnb-testnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3"
      ]
    },
    default: {
      http: [
        `https://opbnb-testnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3`
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "BlockScout",
      url: "https://testnet.opbnbscan.com"
    }
  },
  nativeCurrency: bscTestnet.nativeCurrency
};
var availableChains = {
  optimism,
  optimismGoerli,
  polygon,
  polygonMumbai,
  arbitrum,
  arbitrumGoerli,
  linea,
  lineaTestnet,
  base,
  baseGoerli,
  opBnb: opBnbMainnet,
  scrollSepolia,
  scroll,
  mainnet,
  bscTestnet,
  bsc,
  optimismSepolia
};

// src/EventError.ts
var EventError = class extends Error {
  constructor({
    name,
    details,
    shortMessage
  }) {
    super(
      `${name || "UnknownEventError"}: ${shortMessage || "Unknown error, please check the details"}`
    );
    this.name = name || "UnknownEventError";
    this.details = details;
    this.shortMessage = shortMessage || "Unknown error, please check the details";
  }
};
var EventError_default = EventError;

// src/CyberWallet.ts
var CyberWallet = class {
  constructor({ contextWindow, appInfo }) {
    this.cyberAccount = null;
    this.bindedSendTransaction = this.sendTransaction.bind(this);
    this.contextWindow = contextWindow;
    this.connected = false;
    this.messenger = new Messenger_default({
      walletWindow: this.contextWindow,
      appInfo
    });
    this.cyberAccount = null;
    Object.entries(availableChains).forEach(([key, chain]) => {
      this[key] = new Chain_default({
        id: chain.id,
        sendTransaction: this.bindedSendTransaction,
        appId: appInfo.appId
      });
    });
  }
  setConnection(connected) {
    this.connected = connected;
  }
  setCyberAccount(cyberAccount) {
    this.cyberAccount = cyberAccount;
    localStorage.removeItem("cyber-app-sdk");
    localStorage.setItem("cyber-app-sdk", JSON.stringify(cyberAccount));
    Object.keys(availableChains).forEach((key) => {
      this[key].setCyberAccount(cyberAccount);
    });
  }
  resolveActionResponse(message, reject, resolve) {
    var _a, _b, _c;
    if (message.target === "CyberApp") {
      if (message.event.name === "action") {
        if ((_a = message.event.data) == null ? void 0 : _a.error) {
          if (((_b = message.event.data) == null ? void 0 : _b.method) === "sendTransaction") {
            reject(
              new EventError_default({
                name: "SendTransactionError" /* SendTransactionError */,
                details: message.event.data.error,
                shortMessage: "Transaction failed"
              })
            );
          } else {
            reject(new EventError_default({ details: message.event.data.error }));
          }
        } else {
          resolve((_c = message.event.data) == null ? void 0 : _c.data);
        }
      }
    }
  }
  sendTransaction(transaction) {
    var _a;
    this.messenger.sendMessage({
      name: "action",
      data: {
        type: "request" /* Request */,
        method: "sendTransaction",
        data: {
          transaction: __spreadProps(__spreadValues({}, transaction), {
            from: transaction.from || ((_a = this.cyberAccount) == null ? void 0 : _a.address)
          })
        }
      }
    });
    return new Promise((resolve, reject) => {
      this.messenger.onMessage((message) => {
        this.resolveActionResponse(message, reject, resolve);
      });
    });
  }
  signMessage(message) {
    this.messenger.sendMessage({
      name: "action",
      data: {
        type: "request" /* Request */,
        method: "signMessage",
        data: {
          message
        }
      }
    });
    return new Promise((resolve, reject) => {
      this.messenger.onMessage((message2) => {
        this.resolveActionResponse(message2, reject, resolve);
      });
    });
  }
  signTypedData(typedData) {
    this.messenger.sendMessage({
      name: "action",
      data: {
        type: "request" /* Request */,
        method: "signTypedData",
        data: {
          typedData
        }
      }
    });
    return new Promise((resolve, reject) => {
      this.messenger.onMessage((message) => {
        this.resolveActionResponse(message, reject, resolve);
      });
    });
  }
  getAuthToken() {
    return __async(this, null, function* () {
      this.messenger.sendMessage({
        name: "action",
        data: {
          type: "request" /* Request */,
          method: "getAuthToken"
        }
      });
      return new Promise((resolve, reject) => {
        this.messenger.onMessage((message) => {
          this.resolveActionResponse(message, reject, resolve);
        });
      });
    });
  }
  switchChain(chainId) {
    this.messenger.sendMessage({
      name: "action",
      data: {
        type: "request" /* Request */,
        method: "switchChain",
        data: {
          chainId
        }
      }
    });
    return new Promise((resolve, reject) => {
      this.messenger.onMessage((message) => {
        this.resolveActionResponse(message, reject, resolve);
      });
    });
  }
};
var CyberWallet_default = CyberWallet;

// src/CyberApp.ts
var CyberApp = class {
  constructor({ appId, name, icon }) {
    this.appId = appId;
    this.name = name;
    this.icon = icon;
    this.cyberWallet = new CyberWallet_default({
      contextWindow: window.parent,
      appInfo: { name, icon, appId }
    });
    this.messenger = new Messenger_default({
      walletWindow: this.cyberWallet.contextWindow
    });
  }
  start() {
    return __async(this, null, function* () {
      return yield this.connect();
    });
  }
  connect() {
    return __async(this, null, function* () {
      this.messenger.sendMessage({
        name: "connect"
      });
      return yield new Promise((resolve, reject) => {
        this.messenger.onMessage((message) => {
          var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
          if (message.target === "CyberApp") {
            if (message.event.name === "connect") {
              if (((_b = (_a = message.event.data) == null ? void 0 : _a.data) == null ? void 0 : _b.result) === "success") {
                (_c = this.cyberWallet) == null ? void 0 : _c.setConnection(true);
                (_f = this.cyberWallet) == null ? void 0 : _f.setCyberAccount(
                  (_e = (_d = message.event.data) == null ? void 0 : _d.data) == null ? void 0 : _e.cyberAccount
                );
                resolve((_h = (_g = message.event.data) == null ? void 0 : _g.data) == null ? void 0 : _h.cyberAccount);
              } else {
                if ((_i = message.event.data) == null ? void 0 : _i.error) {
                  reject((_j = message.event.data) == null ? void 0 : _j.error);
                }
              }
            }
          }
        });
      });
    });
  }
};
var CyberApp_default = CyberApp;

// src/CyberProvider.ts
import { EventEmitter } from "events";
import {
  ProviderDisconnectedError,
  createPublicClient,
  http,
  hexToString
} from "viem";
var CyberProvider = class extends EventEmitter {
  constructor({ app, chainId }) {
    super();
    this.name = "CyberWallet";
    this.cyberApp = app;
    this.chainId = chainId;
    this.isMetaMask = false;
    this.chain = this.getChainByChainId(this.chainId);
    this._events = {};
    this.publicClient = this.setPublicClient(this.chainId);
  }
  setPublicClient(chainId) {
    const targetChain = Object.values(availableChains).find(
      (chain) => chain.id === chainId
    );
    return targetChain ? createPublicClient({
      chain: Object.values(availableChains).find(
        (chain) => chain.id === chainId
      ),
      transport: http()
    }) : void 0;
  }
  connect() {
    return __async(this, null, function* () {
      this.emit("connect", { chainId: `0x${this.chainId.toString(16)}` });
      return;
    });
  }
  disconnect() {
    return __async(this, null, function* () {
      this.emit("disconnect", new ProviderDisconnectedError(Error()));
      return;
    });
  }
  getChainKeyByChainId(chainId) {
    const chainObj = Object.entries(availableChains).find(
      ([_, chain]) => chain.id === chainId
    );
    if (!chainObj) {
      console.error(`ChainId ${chainId} is not supported.`);
      return;
    }
    return chainObj[0];
  }
  getChainByChainId(id) {
    var _a;
    const chainKey = this.getChainKeyByChainId(id);
    return chainKey ? (_a = this.cyberApp.cyberWallet) == null ? void 0 : _a[chainKey] : void 0;
  }
  request(request) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      const { method, params = [] } = request;
      switch (method) {
        case "wallet_switchEthereumChain": {
          this.chainId = Number(params[0].chainId);
          this.chain = this.getChainByChainId(this.chainId);
          this.publicClient = this.setPublicClient(this.chainId);
          yield this.cyberApp.cyberWallet.switchChain(this.chainId);
          this.emit("chainChanged", params[0].chainId);
          return;
        }
        case "personal_sign":
          return (_a = this.cyberApp.cyberWallet) == null ? void 0 : _a.signMessage(hexToString(params[0]));
        case "eth_signTypedData":
        case "eth_signTypedData_v4": {
          const [address, typedData] = params;
          const parsedTypedData = typeof typedData === "string" ? JSON.parse(typedData) : typedData;
          if (((_b = this.cyberApp.cyberWallet.cyberAccount) == null ? void 0 : _b.address.toLowerCase()) !== address.toLowerCase()) {
            throw new Error("The address is invalid");
          }
          const signature = yield this.cyberApp.cyberWallet.signTypedData(parsedTypedData);
          return signature || "0x";
        }
        case "eth_chainId":
          return `0x${this.chainId.toString(16)}`;
        case "eth_sendTransaction": {
          const data = params[0].data || "0x";
          return (_c = this.chain) == null ? void 0 : _c.sendTransaction(__spreadProps(__spreadValues({}, params[0]), { data }));
        }
        case "eth_requestAccounts": {
          if (!((_d = this.cyberApp.cyberWallet) == null ? void 0 : _d.cyberAccount)) {
            yield this.cyberApp.connect();
          }
          return [(_f = (_e = this.cyberApp.cyberWallet) == null ? void 0 : _e.cyberAccount) == null ? void 0 : _f.address];
        }
        case "eth_accounts": {
          if (!((_g = this.cyberApp.cyberWallet) == null ? void 0 : _g.cyberAccount)) {
            yield this.cyberApp.connect();
          }
          return [(_i = (_h = this.cyberApp.cyberWallet) == null ? void 0 : _h.cyberAccount) == null ? void 0 : _i.address];
        }
        default:
          return yield (_j = this.publicClient) == null ? void 0 : _j.request({
            method,
            params
          });
      }
    });
  }
};
var CyberProvider_default = CyberProvider;

// src/CyberWalletConnector.ts
import {
  getAddress,
  SwitchChainError,
  numberToHex,
  ClientChainNotConfiguredError
} from "viem";

// src/utils.ts
var isCyberWallet = () => typeof document !== "undefined" && ["https://next.wallet.cyber.co/", "https://wallet.cyber.co/"].includes(
  document.referrer
);
function isChainUnsupported(chainId) {
  return !Object.values(availableChains).map((chain) => chain.id).includes(chainId);
}
function getSignerAddress() {
  const storage = localStorage.getItem("cyber-app-sdk");
  if (!storage) {
    return null;
  }
  const cyberAccountData = JSON.parse(storage);
  return cyberAccountData.ownerAddress;
}

// src/CyberWalletConnector.ts
import { ConnectorNotFoundError, normalizeChainId } from "@wagmi/connectors";
import { createConnector, ProviderNotFoundError } from "@wagmi/core";
function cyberWalletConnector(parameters) {
  const { name, icon, appId, shimDisconnect = false } = parameters;
  const app = new CyberApp_default({
    appId: appId || "",
    name: name || "",
    icon: icon || ""
  });
  let provider_;
  return createConnector((config) => {
    return {
      icon: "",
      id: "cyberWallet",
      name: "CyberWallet",
      type: "cyberWallet",
      connect() {
        return __async(this, null, function* () {
          var _a2, _b;
          const provider = yield this.getProvider();
          if (!provider)
            throw new ConnectorNotFoundError();
          const accounts = yield this.getAccounts();
          const chainId = yield this.getChainId();
          provider.on("disconnect", this.onDisconnect.bind(this));
          provider.on("chainChanged", this.onChainChanged);
          if (shimDisconnect)
            yield (_b = config.storage) == null ? void 0 : _b.removeItem(
              ((_a2 = config.storage) == null ? void 0 : _a2.key) + ".disconnected"
            );
          return { accounts, chainId };
        });
      },
      disconnect() {
        return __async(this, null, function* () {
          var _a2;
          const provider = yield this.getProvider();
          if (!provider)
            throw new ProviderNotFoundError();
          provider.removeListener("disconnect", this.onDisconnect.bind(this));
          if (shimDisconnect)
            yield (_a2 = config.storage) == null ? void 0 : _a2.setItem(
              (config == null ? void 0 : config.storage.key) + ".disconnected",
              true
            );
        });
      },
      getAccounts() {
        return __async(this, null, function* () {
          const provider = yield this.getProvider();
          if (!provider)
            throw new ProviderNotFoundError();
          return (yield provider.request({ method: "eth_accounts" })).map(
            getAddress
          );
        });
      },
      getChainId() {
        return __async(this, null, function* () {
          const provider = yield this.getProvider();
          if (!provider)
            throw new ProviderNotFoundError();
          return normalizeChainId(provider.chainId);
        });
      },
      getProvider: () => __async(this, null, function* () {
        if (provider_)
          return provider_;
        const isInCyberWallet = isCyberWallet();
        if (!isInCyberWallet) {
          console.error("Could not load CyberWallet information.");
        }
        if (!appId) {
          throw Error("CyberWalletConnector: appId is required");
        }
        const cyberProvider = new CyberProvider_default({
          app,
          chainId: config.chains[0].id
          // default chain ID
        });
        provider_ = cyberProvider;
        return provider_;
      }),
      isAuthorized() {
        return __async(this, null, function* () {
          var _a2, _b;
          try {
            const isDisconnected = shimDisconnect && // If shim exists in storage, connector is disconnected
            (yield (_b = config.storage) == null ? void 0 : _b.getItem(
              ((_a2 = config.storage) == null ? void 0 : _a2.key) + ".disconnected"
            ));
            if (isDisconnected)
              return false;
            const accounts = yield this.getAccounts();
            return !!accounts.length;
          } catch (e) {
            return false;
          }
        });
      },
      onAccountsChanged() {
      },
      onChainChanged(chain) {
        const chainId = normalizeChainId(chain);
        config.emitter.emit("change", { chainId });
      },
      onDisconnect() {
        config.emitter.emit("disconnect");
      },
      switchChain(_0) {
        return __async(this, arguments, function* ({ chainId }) {
          const provider = yield this.getProvider();
          if (!provider)
            throw new ProviderNotFoundError();
          const chain = config.chains.find((x) => x.id === chainId);
          if (!chain)
            throw new SwitchChainError(new ClientChainNotConfiguredError());
          try {
            yield provider.request({
              method: "wallet_switchEthereumChain",
              params: [{ chainId: numberToHex(chainId) }]
            });
            return chain;
          } catch (err) {
            const error = err;
            throw new SwitchChainError(error);
          }
        });
      }
    };
  });
}
var CyberWalletConnector_default = cyberWalletConnector;
export {
  CyberApp_default as CyberApp,
  CyberProvider_default as CyberProvider,
  CyberWallet_default as CyberWallet,
  ErrorType,
  EventError_default as EventError,
  EventType,
  CyberWalletConnector_default as cyberWalletConnector,
  getSignerAddress,
  isChainUnsupported,
  isCyberWallet
};
